import React,{ useEffect } from 'react';
import Form from './Form';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { useNavigate,useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useEntityCrud } from '../../hooks/useEntityCrud';

const Update = () => {

    const { id } = useParams();
    const {readData} = useEntityCrud('PersonType/GetPersonType?PersonTypeId=' + id);
    const {addData: updateData} = useEntityCrud('PersonType/UpdatePersonType');
    const navigate = useNavigate();

    const initialValues = {
        title: ''
    };
    
    useEffect(() => {
        readData().then(({data}) => {
            if(data.status)
                formik.setValues({
                    ...data.result
                });
        });
    },[]);
    
    const validationSchema = Yup.object({
        title: Yup.string()
        .required()
    });
    
    const onSubmit = (values) => {
        document.getElementById('btn-submit-form').classList.add('btn-loading');
        const postedData = {
            id,
            title: values.title
       };
        updateData(postedData).then(({data}) => {
            if(data.status){
                toast.success('به روزرسانی نوع پرسنل با موفقیت انجام شد');
                return navigate('/personnel-types');
            }else
                data.errors.map(error => toast.error(error.message));
        }).finally(() => document.getElementById('btn-submit-form').classList.remove('btn-loading'));
    }

    const formik = useFormik({
        initialValues: initialValues,
        onSubmit,
        validationSchema: validationSchema
    });

    const handleBack = () => {
        navigate('/personnel-types',{replace: true});
    }

    return (
        <div className="card">
            <div className="card-header d-flex justify-content-between">
                <div className="card-title">ویرایش نوع پرسنل</div>
                <a className="backIconLink" onClick={handleBack}><i className="fa fa-arrow-left" title="بازگشت"></i></a>
            </div>
            <div className="card-body">
                <Form formik={formik} />
            </div>
        </div>
    );
}

export default Update;